module.exports = __webpack_public_path__ + "static/media/ic-activity.beb3ea8d.svg";